<template>
  <v-flex xs6 class="mr-1">
    <v-card class="mb-2">
      <v-card-title class="mb-2">
        <v-avatar class="secondary">
          <v-icon dark>add_box</v-icon>
        </v-avatar>
        <div class="ml-3">
          <h4 class="headline">Add New Fee Type</h4>
          <span class="body-2">Select the fee type</span>
          <span class="body-2" v-if="feeType === 'tiered'"
            ><br />Fee Tiers require a minimum of 2 entries<br />
            Use zero for a percentage to applied beyond the upper limit (ie Over £10,000)</span
          >
        </div>
      </v-card-title>
      <v-card flat>
        <v-card-text>
          <v-container grid-list-md>
            <v-form>
              <v-layout wrap>
                <v-flex xs3 sm3>
                  <v-select
                    :items="feeTypes"
                    v-model="feeType"
                    hide-selected
                    placeholder="Select the fee type"
                    dense
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
            <v-form lazy-validation v-if="feeType === 'fixed'">
              <v-layout wrap>
                <v-flex xs6 sm3>
                  <v-text-field label="Fixed Fee" v-model="fixedFee" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3 class="text-md-right"><v-btn color="accent" @click="addFixedFee()">Save</v-btn></v-flex>
              </v-layout>
            </v-form>
            <v-form lazy-validation v-else-if="feeType !== null">
              <v-layout wrap v-if="feeType === 'tiered'">
                <v-flex xs6 sm3>
                  <v-text-field label="Upper limit" v-model="secondFeeTier.amount" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field label="Percentage (Prime)" v-model="secondFeeTier.prime_fee" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Percentage (Sub Prime)"
                    v-model="secondFeeTier.sub_prime_fee"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 sm3 v-if="feeType === 'tiered'">
                  <v-text-field label="Upper limit" v-model="feeTier.amount" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field label="Percentage (Prime)" v-model="feeTier.prime_fee" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field label="Percentage (Sub Prime)" v-model="feeTier.sub_prime_fee" required></v-text-field>
                </v-flex>
                <v-flex xs6 sm3 class="text-md-right"
                  ><v-btn color="accent" :disabled="!isValid" @click.native="saveFeeTier">Save</v-btn></v-flex
                >
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'newFeeTier',
  data: () => ({
    feeTier: {
      parent_id: null,
      amount: null,
      prime_fee: null,
      sub_prime_fee: null
    },
    secondFeeTier: {
      parent_id: null,
      amount: null,
      prime_fee: null,
      sub_prime_fee: null
    },
    feeType: null,
    feeTypes: ['fixed', 'percentage', 'tiered'],
    fixedFee: 0
  }),
  computed: {
    ...mapGetters(['SelectedFunder']),
    isValid() {
      let tieredValid = true;
      if (this.feeType === 'tiered') {
        tieredValid =
          !_.isNull(this.secondFeeTier.amount) &&
          !_.isNull(this.secondFeeTier.prime_fee) &&
          !_.isNull(this.secondFeeTier.sub_prime_fee) &&
          !_.isNull(this.feeTier.amount);
      }
      return tieredValid && !_.isNull(this.feeTier.prime_fee) && !_.isNull(this.feeTier.sub_prime_fee);
    }
  },
  methods: {
    ...mapActions(['addFeeTier', 'updateFunder']),
    addFixedFee() {
      const updates = { fixed_fee: this.fixedFee };
      this.updateFunder({ id: this.SelectedFunder.id, updates });
    },
    saveFeeTier() {
      if (this.feeType === 'tiered') {
        this.secondFeeTier.parent_id = this.SelectedFunder.id;
        this.addFeeTier(this.secondFeeTier);
      } else {
        this.feeTier.amount = 0;
      }
      this.feeTier.parent_id = this.SelectedFunder.id;
      this.addFeeTier(this.feeTier);
    },
    resetFees() {
      this.feeTier = {
        parent_id: null,
        amount: null,
        prime_fee: null,
        sub_prime_fee: null
      };
      this.secondFeeTier = {
        parent_id: null,
        amount: null,
        prime_fee: null,
        sub_prime_fee: null
      };
      this.feeType = null;
      this.fixedFee = 0;
    }
  },
  watch: {
    SelectedFunder: function() {
      this.resetFees();
    }
  }
};
</script>

<style lang="scss" scoped></style>
